module.exports = __webpack_public_path__ + "static/media/money-bills-simple.f08e6e95.svg";